import { useState } from 'react';
import { Badge } from '@/components/ui/badge';

function PayloadTab({ label, text }) {
  if (!text) {
    return <p className="text-[10px] text-zinc-400 italic">Sin contenido</p>;
  }
  return (
    <div>
      <span className="text-[9px] font-mono text-zinc-400 uppercase">{label}</span>
      <pre className="text-[10px] font-mono text-zinc-700 bg-white/60 p-2 rounded-sm mt-0.5 overflow-auto max-h-96 whitespace-pre-wrap">{text}</pre>
    </div>
  );
}

export default function LlmCallDetail({ ev }) {
  const [tab, setTab] = useState('response');
  const tabs = [
    { id: 'system', label: 'System' },
    { id: 'user', label: 'User' },
    { id: 'response', label: 'Response' },
  ];

  return (
    <div>
      <div className="flex flex-wrap gap-1.5 mb-2">
        <Badge className="text-[9px] bg-indigo-100 text-indigo-900">
          {ev.purpose || 'llm'} · ronda {(ev.round ?? 0) + 1}
        </Badge>
        <Badge className="text-[9px] bg-zinc-100 text-zinc-700">
          {ev.model_used || `${ev.provider}/${ev.model}`}
        </Badge>
        <Badge className="text-[9px] bg-emerald-50 text-emerald-800">
          tokens {ev.input_tokens ?? 0} → {ev.output_tokens ?? 0}
        </Badge>
        {ev.latency_ms != null && (
          <Badge className="text-[9px] bg-zinc-100 text-zinc-600">{ev.latency_ms} ms</Badge>
        )}
        {ev.request_id && (
          <Badge className="text-[9px] bg-zinc-50 text-zinc-500 font-mono">{ev.request_id.slice(0, 8)}</Badge>
        )}
      </div>

      <div className="flex gap-1 mb-2">
        {tabs.map((t) => (
          <button
            key={t.id}
            type="button"
            onClick={() => setTab(t.id)}
            className={`text-[9px] px-2 py-0.5 rounded border ${
              tab === t.id ? 'bg-zinc-800 text-white border-zinc-800' : 'bg-white text-zinc-600 border-zinc-200'
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {tab === 'system' && <PayloadTab label="System prompt completo" text={ev.system_prompt_full} />}
      {tab === 'user' && <PayloadTab label="User message completo" text={ev.user_message_full} />}
      {tab === 'response' && <PayloadTab label="Respuesta del modelo" text={ev.assistant_response_full} />}

      {ev.payload_meta && (
        <p className="text-[9px] text-zinc-400 mt-2 font-mono">
          hash system: {ev.payload_meta?.system?.hash?.slice(0, 12)} · user: {ev.payload_meta?.user?.hash?.slice(0, 12)}
        </p>
      )}
    </div>
  );
}
